export default [
    { value : "Mensal", text : "Mensal"},
    { value : "Bimestral", text : "Bimestral"},
    { value : "Trimestral", text : "Trimestral"},
    { value : "Quadrimestral", text : "Quadrimestral"},
    { value : "Semestral", text : "Semestral"},
    { value : "Anual", text : "Anual"},
]